(function () {
  // --- CACHE DOM ELEMENTS ---
  const cache = {};

  // --- DECLARACIONES GLOBALES ---
  let jsonDataPro = {};
  let themeData = {};
  let outsideClickHandler = null; // Para gestionar click outside de toggles

  // Use centralized thresholds from shipping-cost.js (backward compatible)
  // If SHIPPING_THRESHOLDS is not available yet, use local fallback
  const minTotalPrice = window.SHIPPING_THRESHOLDS || {
    9: 9800,      // 98€ for 9€ shipping (EU)
    23: 23000,    // £230 for £23 shipping (UK)
    35: 35000,    // $350 for $35 shipping (US)
    40: 45000,    // $450 CAD for $40 shipping (Canada)
    49: 49500,    // $495 AUD for $49 shipping (Australia)
    240: 250000,  // 2500 NOK for 240 NOK shipping (Norway)
    25: 24000,    // 240 CHF for 25 CHF shipping (Switzerland)
    39: 39900,    // 399 SGD for 39 SGD shipping (Singapore)
    117: 120000,  // 1200 AED for 117 AED shipping (Arab emirates)
    290: 260000,  // 2600 SEK for 290 SEK shipping (Sweden)
    null: 27500,  // Default fallback
    "": 27500     // Empty string fallback
  };

  const holidays = new Set([
    "2026-01-01", // Año Nuevo
    "2026-01-06", // Reyes / Epifanía
    "2026-04-03", // Viernes Santo
    "2026-04-06", // Lunes de Pascua
    "2026-05-01", // Día del Trabajador
    "2026-06-24", // San Juan
    "2026-08-15", // Asunción
    "2026-09-11", // Diada Nacional de Catalunya
    "2026-10-12", // Fiesta Nacional de España
    "2026-12-08", // Inmaculada Concepción
    "2026-12-25", // Navidad
    "2026-12-26"  // Sant Esteve
  ]);


  // Express shipping costs by country - amounts only, symbol added dynamically
  const expressShippingCosts = {
    // Countries with specific local currencies (symbol included for non-standard currencies)
    BA: { amount: 38, symbol: 'KM' },      // Bosnia - Convertible Mark
    BG: { amount: 38, symbol: 'лв' },      // Bulgaria - Lev
    CZ: { amount: 474, symbol: 'Kč' },     // Czech - Koruna
    DK: { amount: 142, symbol: 'kr' },     // Denmark - Krone
    HU: { amount: 7652, symbol: 'Ft' },    // Hungary - Forint
    IS: { amount: 2788, symbol: 'kr' },    // Iceland - Króna
    LI: { amount: 18, symbol: 'CHF' },     // Liechtenstein - Swiss Franc
    NO: { amount: 221, symbol: 'kr' },     // Norway - Krone
    PL: { amount: 81, symbol: 'zł' },      // Poland - Złoty
    RO: { amount: 97, symbol: 'lei' },     // Romania - Leu
    RS: { amount: 2230, symbol: 'РСД' },   // Serbia - Dinar
    SE: { amount: 208, symbol: 'kr' },     // Sweden - Krona
    CH: { amount: 18, symbol: 'CHF' },     // Switzerland - Swiss Franc
    TR: { amount: 826, symbol: '₺' },      // Turkey - Lira
    HK: { amount: 180, symbol: 'HK$' },    // Hong Kong - Dollar
    AE: { amount: 76, symbol: 'AED' },     // UAE - Dirham
    
    // Countries using Shopify Markets currencies (symbol from cart.currency.symbol)
    CA: { amount: 45, useMarketCurrency: true },   // Canada - CAD
    US: { amount: 22, useMarketCurrency: true },   // USA - USD
    USA: { amount: 22, useMarketCurrency: true },  // USA - USD
    UK: { amount: 16, useMarketCurrency: true },   // UK - GBP
    GB: { amount: 16, useMarketCurrency: true },   // UK - GBP
    
    // EU Countries - use € symbol or market currency
    CY: { amount: 21, useMarketCurrency: true },   // Cyprus
    MT: { amount: 21, useMarketCurrency: true },   // Malta
    SG: { amount: 45, symbol: 'S$' },              // Singapore - SGD
    HR: { amount: 19, useMarketCurrency: true },   // Croatia
    EE: { amount: 19, useMarketCurrency: true },   // Estonia
    FI: { amount: 19, useMarketCurrency: true },   // Finland
    DE: { amount: 19, useMarketCurrency: true },   // Germany
    GR: { amount: 19, useMarketCurrency: true },   // Greece
    IE: { amount: 19, useMarketCurrency: true },   // Ireland
    LV: { amount: 19, useMarketCurrency: true },   // Latvia
    LT: { amount: 19, useMarketCurrency: true },   // Lithuania
    LU: { amount: 19, useMarketCurrency: true },   // Luxembourg
    MC: { amount: 19, useMarketCurrency: true },   // Monaco
    ME: { amount: 19, useMarketCurrency: true },   // Montenegro
    NL: { amount: 19, useMarketCurrency: true },   // Netherlands
    PT: { amount: 19, useMarketCurrency: true },   // Portugal
    SM: { amount: 19, useMarketCurrency: true },   // San Marino
    SK: { amount: 19, useMarketCurrency: true },   // Slovakia
    SI: { amount: 19, useMarketCurrency: true },   // Slovenia
    VA: { amount: 19, useMarketCurrency: true },   // Vatican
    FR: { amount: 19, useMarketCurrency: true },   // France
    IT: { amount: 19, useMarketCurrency: true },   // Italy
    ES: { amount: 19, useMarketCurrency: true },   // Spain
    AT: { amount: 19, useMarketCurrency: true },   // Austria
    BE: { amount: 19, useMarketCurrency: true },   // Belgium
    
    default: { amount: 35, useMarketCurrency: true }
  };
  
  // Helper function to format express shipping cost with correct currency
  function formatExpressCost(countryCode) {
    const costInfo = expressShippingCosts[countryCode] || expressShippingCosts.default;
    
    if (costInfo.useMarketCurrency) {
      // Use the currency symbol from Shopify Markets (location-based)
      const currencySymbol = window.customStrings?.currency_symbol || '€';
      return currencySymbol + costInfo.amount;
    } else {
      // Use the hardcoded symbol for countries with specific local currencies
      return costInfo.symbol + costInfo.amount;
    }
  }

  // --- CACHE DOM FUNCTION ---
  function cacheDOM() {
    cache.productJSON = document.querySelector('[data-product-json]');
    cache.variants = document.querySelectorAll('.variant input[type="radio"]');
    cache.shippingBox = document.querySelector('#main-shipping-info');
    cache.tabOverlay = document.getElementById('TabContentOverlay');
    cache.firstColumn = document.querySelector('.firstColumn');
    cache.productInfo = document.getElementsByTagName('product-info')[0];
    cache.completeLook = document.querySelector('#complete-look');
    
    // Modal elements
    cache.gptModal = document.getElementById("gpt");
    cache.tabContents = document.getElementsByClassName("tab-content");
    cache.tabButtons = document.getElementsByClassName("tab");

    if (cache.completeLook) cache.completeLook.style.display = 'none';
  }

  // --- STICKY BEHAVIOR VALIDATION ---
  function shouldEnableSticky() {
    const isDesktop = window.innerWidth > 767;
    if (!isDesktop) return false;
    
    const productInfoElement = cache.productInfo || document.getElementsByTagName('product-info')[0];
    if (!productInfoElement) return false;
    
    const productInfoHeight = productInfoElement.offsetHeight;
    const viewportHeight = window.innerHeight;
    
    // Only enable if content overflows viewport
    return productInfoHeight > viewportHeight;
  }

  // --- DOM READY INIT ---
  document.addEventListener('DOMContentLoaded', () => {
    // Cache DOM elements first
    cacheDOM();
    
    // Inicializar datos
    if (cache.productJSON) jsonDataPro = JSON.parse(cache.productJSON.innerHTML);
    
    // Usar window.themeData si está disponible (más actualizado), sino usar localStorage
    // window.themeData es actualizado por shipping-cost.js de forma asíncrona
    if (window.themeData && window.themeData.country_code) {
      themeData = window.themeData;
      console.log('✅ [product_detail] Usando window.themeData:', themeData);
    } else {
      themeData = JSON.parse(localStorage.getItem('themeData') || '{}');
      console.log('⚠️ [product_detail] Usando localStorage (window.themeData no disponible aún):', themeData);
      
      // Verificar si el país guardado parece incorrecto (ej: Bermuda cuando debería ser ES)
      // Si window.Shopify.country está disponible, comparar
      if (window.Shopify && window.Shopify.country && themeData.country_code) {
        const shopifyCountry = window.Shopify.country;
        if (themeData.country_code !== shopifyCountry) {
          console.warn('⚠️ [product_detail] Discrepancia detectada:', {
            localStorage: themeData.country_code,
            shopify: shopifyCountry,
            accion: 'Esperando actualización de shipping-cost.js'
          });
          // Limpiar localStorage para forzar nueva detección
          localStorage.removeItem('themeData');
        }
      }
      
      // Si window.themeData se actualiza después, sincronizar
      const checkThemeData = setInterval(() => {
        if (window.themeData && window.themeData.country_code) {
          // Si el país cambió, actualizar inmediatamente
          if (window.themeData.country_code !== themeData.country_code) {
            themeData = window.themeData;
            console.log('🔄 [product_detail] País actualizado, sincronizado con window.themeData:', themeData);
            updateVariantBorders(); // Actualizar con los datos correctos
            clearInterval(checkThemeData);
          } else if (!themeData.country_code) {
            // Si no teníamos país, usar el de window.themeData
            themeData = window.themeData;
            console.log('🔄 [product_detail] Sincronizado con window.themeData:', themeData);
            updateVariantBorders();
            clearInterval(checkThemeData);
          }
        }
      }, 100);
      
      // Dejar de verificar después de 5 segundos (aumentado para dar más tiempo)
      setTimeout(() => clearInterval(checkThemeData), 5000);
    }

    // Setup event listeners
    setupGlobalEventListeners();
    
    // Initialize functionality
    updateVariantBorders();
    setupVariantListeners();
    // setupToggleDivScroll(); // Sticky behavior disabled
    
    showCompleteLookIfPresent();
    
  });

  // --- GLOBAL EVENT LISTENERS ---
  function setupGlobalEventListeners() {
    // Single click handler for all interactions
    document.addEventListener('click', handleGlobalClick);
    
    // Keyboard handler
    document.addEventListener('keydown', handleKeydown);
  }

  function handleGlobalClick(event) {
    // Handle size chart modal
    if (event.target === cache.gptModal) {
      event.stopPropagation();
      event.preventDefault();
      openMeasureModal();
      return;
    }

    // Handle outside clicks for toggle divs
    if (outsideClickHandler) {
      outsideClickHandler(event);
    }
  }

  function handleKeydown(event) {
    // Close modal on Escape
    if (event.key === "Escape" && cache.gptModal) {
      cache.gptModal.classList.remove("show");
      document.body.style.overflow = '';
    }
  }

  // --- MODAL FUNCTIONS ---
  window.openMeasureModal = function() {
    if (!cache.gptModal) return;
    
    const isOpen = cache.gptModal.classList.contains("show");
    
    if (isOpen) {
      cache.gptModal.classList.remove("show");
      document.body.style.overflow = '';
    } else {
      cache.gptModal.classList.add("show");
      document.body.style.overflow = 'hidden';
    }
  };

  window.showTabContent = function(tabIndex) {
    if (!cache.tabContents || !cache.tabButtons) return;
    
    for (let i = 0; i < cache.tabContents.length; i++) {
      const isActive = i + 1 === tabIndex;
      cache.tabContents[i].classList.toggle("active", isActive);
      cache.tabButtons[i].classList.toggle("active", isActive);
    }
  };

  window.showSubTabContent = function(subTabIndex, tabContentId) {
    const tabContent = document.getElementById(tabContentId);
    if (!tabContent) return;
    
    const subTabContents = tabContent.getElementsByClassName("sub-tab-content");
    const subTabButtons = tabContent.getElementsByClassName("sub-tab");
    
    for (let i = 0; i < subTabContents.length; i++) {
      const isActive = i + 1 === subTabIndex;
      subTabContents[i].classList.toggle("active", isActive);
      subTabButtons[i].classList.toggle("active", isActive);
    }
  };

  // --- TABS & TOGGLES ---
window.handleTabInteraction = function (evt, type, targetId) {
  const isToggle = type === 'toggle';
  const isTab = type === 'tab';

  const clearToggleUnderscores = () => {
    document.querySelectorAll('.modal_opener a').forEach(el => el.style.textDecoration = 'none');
  };

  if (isToggle) {
    const overlay = document.getElementById('TabContentOverlay');
    if (!overlay) return;
    
    const contentContainer = overlay.querySelector('.tab-overlay-content');
    const template = document.getElementById('tab-templates');
    
    if (!template || !contentContainer) return;
    
    const isHidden = !overlay.classList.contains('active');
    const currentTab = overlay.dataset.currentTab;
    
    clearToggleUnderscores();

    if (isHidden || currentTab !== targetId) {
      const templateContent = template.content.querySelector(`[data-tab-content="${targetId}"]`);
      if (templateContent) {
        contentContainer.innerHTML = templateContent.innerHTML;
        overlay.classList.add('active');
        overlay.dataset.currentTab = targetId;
        evt.currentTarget.style.textDecoration = 'underline';

        setupOutsideClickHandler(overlay);
        evt.stopPropagation();
      }
    } else {
      closeTabOverlay();
    }
  }

  if (isTab) {
    const tabContents = document.querySelectorAll('.tabsphone');
    const tabBtns = document.querySelectorAll('.tab-btn');

    tabContents.forEach(tab => tab.classList.remove('active'));
    tabBtns.forEach(btn => {
      btn.classList.remove('active');
      btn.style.textDecoration = 'none';
    });

    document.getElementById(targetId)?.classList.add('active');
    evt.currentTarget.classList.add('active');
    evt.currentTarget.style.textDecoration = 'underline';
  }
};

// --- ÚNICA VERSIÓN DE CIERRE (Mantenla así) ---
window.closeTabOverlay = function() {
  const overlay = document.getElementById('TabContentOverlay');
  if (overlay) {
    overlay.classList.remove('active');
    overlay.dataset.currentTab = '';
    
    // Limpieza de underscores
    document.querySelectorAll('.modal_opener a').forEach(el => {
      el.style.textDecoration = 'none';
    });
    
    removeOutsideClickHandler();
  }
};

  function setupOutsideClickHandler(targetDiv) {
    removeOutsideClickHandler(); // Remove previous handler
    
    outsideClickHandler = function(event) {
      const contentDiv = targetDiv.querySelector('.tab-overlay-content');
      const closeButton = targetDiv.querySelector('.close-tab-overlay');
      
      // Cerrar si hacemos click fuera del contenido (pero dentro del overlay o fuera)
      if (!isContentChild(event.target, contentDiv) && !isContentChild(event.target, closeButton)) {
        closeTabOverlay();
      }
    };
    
    // Agregar listener con un pequeño delay para evitar cerrar inmediatamente
    setTimeout(() => {
      document.addEventListener('click', outsideClickHandler);
    }, 10);
  }

  function removeOutsideClickHandler() {
    if (outsideClickHandler) {
      document.removeEventListener('click', outsideClickHandler);
      outsideClickHandler = null;
    }
  }

  function isContentChild(element, targetDiv) {
    return targetDiv && (targetDiv === element || targetDiv.contains(element));
  }

  // --- COMPLEMENTARY ---
  function showCompleteLookIfPresent() {
    setTimeout(() => {
      // 1. Buscamos el contenedor de la App (Frequently Bought)
      const appContainer = document.querySelector('.cbb-frequently-bought-container');
      
      if (appContainer && cache.completeLook) {
        // 2. Si la App cargó, decidimos el tipo de display según el dispositivo
        if (window.innerWidth <= 768) {
          cache.completeLook.style.display = 'inline';
        } else {
          // En escritorio aplicamos block (que ahora funcionará sin el !important)
          cache.completeLook.style.display = 'block';
        }
      } else if (cache.completeLook) {
        // 3. Si la App NO cargó, nos aseguramos de que siga oculto
        cache.completeLook.style.display = 'none';
      }
    }, 1200); // Un pelín más de tiempo para asegurar que la App de terceros inyectó su HTML
  }

  // --- VARIANTS ---
  function setupVariantListeners() {
    const variants = cache.variants || document.querySelectorAll('.variant input[type="radio"]');
    variants.forEach(variant => variant.addEventListener('change', updateVariantBorders));
  }

  function updateVariantBorders() {
    const selectedVariant = document.querySelector('.variant input[type="radio"]:checked');
    const giftCardPro = jsonDataPro['product']?.tags?.includes("Gift Card");
  
    // Siempre usar window.themeData si está disponible (más actualizado)
    const currentThemeData = window.themeData && window.themeData.country_code 
      ? window.themeData 
      : themeData;
    
    if (!giftCardPro) {
      let selectedVariantId;
      
      if (selectedVariant) {
        // Hay variantes y una está seleccionada
        selectedVariantId = selectedVariant.getAttribute('data-variant-id');
      } else {
        // No hay variantes o ninguna seleccionada - usar el producto principal
        selectedVariantId = jsonDataPro.selected_variant_id || 
                           jsonDataPro.product?.variants?.[0]?.id ||
                           null;
      }
      
      builderBox(
        currentThemeData.shippingCost,
        currentThemeData.country_name,
        minTotalPrice,
        selectedVariantId
      );
    }
  }

  // --- ENVÍO Y FECHAS ---
  function addBusinessDays(days, checkHolidays = true) {
    const currentDate = new Date();
    
    // 1. Detectar idioma (usando la variable que añadimos a theme.liquid)
    const lang = (window.themeTranslations && window.themeTranslations.language) || 'en';

    // 2. Lógica de hora de corte (12:00 PM Madrid)
    const spanishTime = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Madrid',
      hour: '2-digit',
      minute: '2-digit'
    }).format(currentDate);

    const [hours, minutes] = spanishTime.split(':').map(num => parseInt(num, 10));
    if (hours > 12 || (hours === 12 && minutes > 0)) days++;

    // 3. Calcular días hábiles saltando fines de semana y festivos
    let count = 0;
    while (count < days) {
      currentDate.setDate(currentDate.getDate() + 1);
      if (currentDate.getDay() !== 0 && currentDate.getDay() !== 6) {
        let formattedDate = currentDate.toISOString().split('T')[0];
        if (checkHolidays && typeof holidays !== 'undefined' && holidays.has(formattedDate)) continue;
        count++;
      }
    }

    const dayOfMonth = currentDate.getDate();
    // 4. Traducir mes según el idioma de la tienda
    const month = currentDate.toLocaleString(lang, { month: 'short' });

    // 5. Retornar formato según el idioma
    if (lang === 'es') {
      // Formato para España: "23 dic"
      return `${dayOfMonth} ${month}`;
    } else {
      // Formato para Inglés: "Dec 23rd"
      const ordinalDay = getOrdinalSuffix(dayOfMonth);
      return `${month} ${ordinalDay}`;
    }
  }

  function getOrdinalSuffix(day) {
    const lang = window.themeTranslations.language || 'en';
    if (lang === 'es') return day; // En español simplemente devolvemos el número

    // English format: "23rd" with ordinal suffix (same logic as formatPreOrderDate)
    const suffixes = ["th", "st", "nd", "rd"];
    const n = day % 100;
    const suffix = (n >= 11 && n <= 13) ? "th" : (suffixes[n % 10] || "th");
    return `${day}${suffix}`;
  }

  // Parse date-only string (meta has no time). "YYYY-MM-DD" -> local Date at midnight.
  function parseDateOnly(dateStr) {
    if (!dateStr || typeof dateStr !== 'string') return null;
    const s = dateStr.trim();
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (!m) return null;
    const date = new Date(parseInt(m[1], 10), parseInt(m[2], 10) - 1, parseInt(m[3], 10));
    return isNaN(date.getTime()) ? null : date;
  }

  function formatPreOrderDate(dateString) {
    if (!dateString) return '';
    const lang = (window.themeTranslations && window.themeTranslations.language) || 'en';
    const date = parseDateOnly(dateString);
    if (!date) return '';
    const day = date.getDate();
    const month = date.toLocaleString(lang, { month: 'short' });
    if (lang === 'es') return `${day} ${month}`;
    // English format: "Feb 28th" with ordinal suffix
    const suffixes = ["th", "st", "nd", "rd"];
    const n = day % 100;
    const suffix = (n >= 11 && n <= 13) ? "th" : (suffixes[n % 10] || "th");
    return `${month} ${day}${suffix}`;
  }

  async function applyer(string, array) {
    try {
      const response = await fetch("/cart.js");
      if (!response.ok) throw new Error("Failed to fetch cart data");
      const data = await response.json();
      const totalPrice = data.items_subtotal_price + jsonDataPro.product.price;
      
      // Convert shippingCost to number if it's a string (e.g., "9" or "9 €" -> 9)
      let shippingCostKey = string;
      if (typeof string === 'string') {
        // Extract number from string (handles "9", "9 €", "€9", etc.)
        const numericMatch = string.match(/\d+/);
        shippingCostKey = numericMatch ? parseInt(numericMatch[0], 10) : null;
      } else if (string != null) {
        shippingCostKey = parseInt(string, 10);
      }
      
      // Get threshold, fallback to default if key doesn't exist
      const threshold = array[shippingCostKey] || array[null] || array[""] || 27500;
      
      const qualifies = totalPrice >= threshold;
      
      return qualifies;
    } catch (error) {
      console.error("❌ [applyer] Error fetching cart data:", error);
      return false;
    }
  }

async function builderBox(shippingCost, country, priceThresholds, variantID) {
  const container = cache.shippingBox || document.querySelector('#main-shipping-info');
  if (!container) return;

  container.innerHTML = '';
  container.style.display = 'none';

  const variant = getVariantById(variantID || jsonDataPro.selected_variant_id);
  if (!variant?.available) return;

  // Variant data: keys in JSON are strings (e.g. "56465822122328"), variant.id can be number
  const variantData = jsonDataPro[variant.id] ?? jsonDataPro[String(variant.id)];
  const rawPreOrder = variantData?.pre_order_date;
  
  // Normalize: Liquid outputs date metafield .value as string via | json (e.g. "2025-02-28" or null)
  // Handle both string and object cases, filter out null, empty, or "null" string
  let preOrderDateStr = null;
  if (rawPreOrder != null) {
    let dateValue = null;
    if (typeof rawPreOrder === 'string') {
      dateValue = rawPreOrder;
    } else if (rawPreOrder && typeof rawPreOrder.value === 'string') {
      dateValue = rawPreOrder.value;
    }
    
    if (dateValue) {
      const trimmed = String(dateValue).trim();
      // Must be valid YYYY-MM-DD format and not "null" string
      if (trimmed && trimmed !== 'null' && /^\d{4}-\d{2}-\d{2}/.test(trimmed)) {
        preOrderDateStr = trimmed;
      }
    }
  }

  // Check if date is valid and today or future
  let preOrderDate = null;
  if (preOrderDateStr) {
    const parsed = parseDateOnly(preOrderDateStr);
    if (parsed) {
      const todayStart = new Date();
      todayStart.setHours(0, 0, 0, 0);
      if (parsed >= todayStart) {
        preOrderDate = preOrderDateStr;
      }
    }
  }
  const qualifiesForFreeShipping = await applyer(shippingCost, priceThresholds);
  const hasShippingCost = shippingCost != null && shippingCost !== '';
  
  // ==========================================================
  // CÁLCULO DE TEXTOS (LÓGICA DEL CÓDIGO ORIGINAL)
  // ==========================================================
  
  // Check if country is US or USA for duties text (ES added for testing)
  const isUS = themeData.country_code === 'US' || themeData.country_code === 'USA' || 
                 country === 'US' || country === 'USA';
  
  // Ensure country name is translated (use themeData.country_name which is always translated)
  const translatedCountry = window.themeData?.country_name || country;
  
  // Get currency symbol for shipping cost display
  const currencySymbol = window.customStrings?.currency_symbol || '';
  const formattedShippingCost = hasShippingCost ? currencySymbol + shippingCost : '';
                 
  // 1. Texto de envío
  const shippingText = qualifiesForFreeShipping
      ? window.themeTranslations.free_delivery.replace('{{ country }}', translatedCountry)
      : hasShippingCost 
        ? window.themeTranslations.estimated_cost.replace('{{ country }}', translatedCountry).replace('{{ cost }}', formattedShippingCost)
        : window.themeTranslations.calculated_at_checkout.replace('{{ country }}', translatedCountry);
        
  // 2. Texto de tiempo de entrega
  // Format the pre-order date based on the current language
  const formattedPreOrderDate = preOrderDate ? formatPreOrderDate(preOrderDate) : null;
  const deliveryText = formattedPreOrderDate
    ? window.themeTranslations.preorder_starts.replace('{{ date }}', formattedPreOrderDate)
    : hasShippingCost 
      ? window.themeTranslations.arrives_between.replace('{{ min }}', addBusinessDays(3)).replace('{{ max }}', addBusinessDays(5))
      : window.themeTranslations.delivery_calculated;
      
  // ==========================================================
  // CASO 1: GESTIÓN DE PRE-ORDER (NUEVO ESTILO, ORDEN INVERSO DE LA INFO)
  // ==========================================================
  if (preOrderDate) {
      const preOrderBox = document.createElement('div');
      preOrderBox.className = 'shipping-box pre-order-info'; 
      
      // SVG del express shipping (paquete) - mismo que shipping-box second
      const preOrderSvgMarkup = `
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" height="18" width="18">
          <path stroke-linejoin="round" stroke-linecap="round" stroke-width="1.5" stroke="#0032A7"
            d="M5.625 7.125L12.3751 3M9.00009 9.375L15.7501 5.25M9.00009 9.375L2.25009 5.25M9.00009 9.375V16.875M7.12509 16.125V16.125C7.44574 16.3174 7.60607 16.4136 7.76491 16.4854C8.55015 16.8401 9.45003 16.8401 10.2353 16.4854C10.3941 16.4136 10.5544 16.3174 10.8751 16.125L14.1697 14.1483C15.0195 13.6384 15.4444 13.3834 15.753 13.0324C16.0261 12.7218 16.2321 12.3581 16.3579 11.9641C16.5001 11.5188 16.5001 11.0233 16.5001 10.0323V7.96771C16.5001 6.97669 16.5001 6.48117 16.3579 6.03593C16.2321 5.64192 16.0261 5.27818 15.753 4.96757C15.4444 4.61657 15.0195 4.36163 14.1697 3.85175L11.4697 2.23175C10.5718 1.69301 10.1228 1.42364 9.64356 1.31839C9.21963 1.2253 8.78055 1.2253 8.35663 1.31839C7.87736 1.42364 7.42841 1.69301 6.53051 2.23175L3.10789 4.28532C2.96114 4.37337 2.88776 4.4174 2.82122 4.46233C2.04211 4.98844 1.55467 5.84935 1.50439 6.78811C1.50009 6.86828 1.50009 6.95386 1.50009 7.125V7.125M0.75 9.75H4.75781M1.75781 12H5.50781M3.25781 14.25H6.25781"/>
        </svg>
      `;
      preOrderBox.insertAdjacentHTML('beforeend', preOrderSvgMarkup);
      
      const textContainer = document.createElement('div');
      textContainer.className = 'shipping-text-container';

      // 1. Línea Superior (TIEMPO DE ENTREGA: Shipping starts...)
      textContainer.appendChild(createTextBlock('top', deliveryText)); 
      
      // 2. Línea Inferior (COSTE: Free delivery / Estimated shipping cost)
      textContainer.appendChild(createTextBlock('sub', shippingText)); 

      preOrderBox.appendChild(textContainer);
      container.appendChild(preOrderBox);
      container.style.display = 'block'; 
      
      return; 
  }
  
  // ==========================================================
  // CASO 2: ENVÍO NORMAL (Tu código con corrección de threshold)
  // ==========================================================

  // --- Shipping Box 1: ARRIVES + Express ---
  const firstBox = document.createElement('div');
  firstBox.className = 'shipping-box first';
  
  if (hasShippingCost) {
    // Crear express_container
    const expressContainer = document.createElement('div');
    expressContainer.className = 'express_container';
    
    const detailsElement = document.createElement('details');
    const summaryElement = document.createElement('summary');
    
    // Div express_shipping con SVG + shipping-text-container
    const expressShippingDiv = document.createElement('div');
    expressShippingDiv.className = 'express_shipping';
    
    // SVG checkmark
    const svgMarkup = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
        <path fill="#0032A7" fill-rule="evenodd" d="M10.559.725c.414.12.784.437 1.523 1.07l.215.186c.284.243.426.365.584.456a2 2 0 0 0 .645.239c.179.033.366.033.74.033.955 0 1.433 0 1.808.16a2 2 0 0 1 1.057 1.056c.16.376.16.853.16 1.809 0 .374 0 .56.033.74a2 2 0 0 0 .238.645c.092.157.214.3.457.583l.185.216c.633.739.95 1.109 1.071 1.523a2 2 0 0 1 0 1.119c-.12.414-.438.784-1.071 1.523l-.185.216c-.243.284-.365.426-.457.583a2 2 0 0 0-.238.645c-.033.18-.033.366-.033.74 0 .956 0 1.433-.16 1.808a2 2 0 0 1-1.057 1.057c-.375.16-.853.16-1.808.16-.374 0-.561 0-.74.033a2 2 0 0 0-.645.239c-.158.091-.3.213-.584.456l-.215.185c-.74.634-1.109.95-1.524 1.071a2 2 0 0 1-1.118 0c-.415-.12-.784-.437-1.523-1.07l-.21-.18c-.29-.25-.435-.373-.596-.466a2 2 0 0 0-.631-.234c-.183-.034-.375-.034-.759-.034-.969 0-1.454 0-1.832-.162a2 2 0 0 1-1.048-1.048c-.162-.378-.162-.86-.162-1.823 0-.374 0-.561-.033-.74a2 2 0 0 0-.233-.635c-.09-.158-.211-.301-.453-.586l-.194-.229c-.622-.735-.934-1.102-1.053-1.514a2 2 0 0 1 0-1.11c.12-.41.43-.778 1.053-1.513l.194-.229c.242-.285.363-.428.453-.586a2 2 0 0 0 .233-.635c.033-.179.033-.366.033-.74 0-.963 0-1.445.162-1.823A2 2 0 0 1 3.89 2.871c.379-.162.863-.162 1.832-.162.384 0 .576 0 .759-.034a2 2 0 0 0 .631-.234c.161-.093.306-.217.596-.465l.21-.18C8.656 1.162 9.025.846 9.44.725a2 2 0 0 1 1.119 0Zm3.304 6.245a.75.75 0 0 0-1.06 0l-3.637 3.635L8.03 9.47a.75.75 0 1 0-1.06 1.06l1.667 1.667a.751.751 0 0 0 1.06 0l4.166-4.167a.75.75 0 0 0 0-1.06Z" clip-rule="evenodd"/>
      </svg>
    `;
    expressShippingDiv.insertAdjacentHTML('beforeend', svgMarkup);
    
    // Shipping text container
    const textContainer = document.createElement('div');
    textContainer.className = 'shipping-text-container';
    textContainer.appendChild(createTextBlock('top', window.themeTranslations.arrives_range.replace('{{ range }}', getDeliveryRange(3, 5))));
    textContainer.appendChild(createTextBlock('sub', window.themeTranslations.need_it_sooner));
    
    expressShippingDiv.appendChild(textContainer);
    const caretIcon = document.createElement('span');
    caretIcon.className = 'icon icon-caret';
    caretIcon.innerHTML = `<svg aria-hidden="true" focusable="false" viewBox="0 0 10 6">
      <path fill-rule="evenodd" clip-rule="evenodd"
        d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z"
        fill="currentColor">
    </svg>`;
    expressShippingDiv.appendChild(caretIcon);
    
    summaryElement.appendChild(expressShippingDiv);
    detailsElement.appendChild(summaryElement);
    
    // Contenido expandible
    const expressContent = createExpressContentOnly();
    detailsElement.appendChild(expressContent);
    
    expressContainer.appendChild(detailsElement);
    firstBox.appendChild(expressContainer);
    
    // Toggle class on firstBox when details opens/closes
    detailsElement.addEventListener('toggle', function() {
      if (this.open) {
        firstBox.classList.add('open');
      } else {
        firstBox.classList.remove('open');
      }
    });
  } else {
    // Sin shipping cost - estructura simple
    const svgMarkup = `
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none">
        <path fill="#0032A7" fill-rule="evenodd" d="M10.559.725c.414.12.784.437 1.523 1.07l.215.186c.284.243.426.365.584.456a2 2 0 0 0 .645.239c.179.033.366.033.74.033.955 0 1.433 0 1.808.16a2 2 0 0 1 1.057 1.056c.16.376.16.853.16 1.809 0 .374 0 .56.033.74a2 2 0 0 0 .238.645c.092.157.214.3.457.583l.185.216c.633.739.95 1.109 1.071 1.523a2 2 0 0 1 0 1.119c-.12.414-.438.784-1.071 1.523l-.185.216c-.243.284-.365.426-.457.583a2 2 0 0 0-.238.645c-.033.18-.033.366-.033.74 0 .956 0 1.433-.16 1.808a2 2 0 0 1-1.057 1.057c-.375.16-.853.16-1.808.16-.374 0-.561 0-.74.033a2 2 0 0 0-.645.239c-.158.091-.3.213-.584.456l-.215.185c-.74.634-1.109.95-1.524 1.071a2 2 0 0 1-1.118 0c-.415-.12-.784-.437-1.523-1.07l-.21-.18c-.29-.25-.435-.373-.596-.466a2 2 0 0 0-.631-.234c-.183-.034-.375-.034-.759-.034-.969 0-1.454 0-1.832-.162a2 2 0 0 1-1.048-1.048c-.162-.378-.162-.86-.162-1.823 0-.374 0-.561-.033-.74a2 2 0 0 0-.233-.635c-.09-.158-.211-.301-.453-.586l-.194-.229c-.622-.735-.934-1.102-1.053-1.514a2 2 0 0 1 0-1.11c.12-.41.43-.778 1.053-1.513l.194-.229c.242-.285.363-.428.453-.586a2 2 0 0 0 .233-.635c.033-.179.033-.366.033-.74 0-.963 0-1.445.162-1.823A2 2 0 0 1 3.89 2.871c.379-.162.863-.162 1.832-.162.384 0 .576 0 .759-.034a2 2 0 0 0 .631-.234c.161-.093.306-.217.596-.465l.21-.18C8.656 1.162 9.025.846 9.44.725a2 2 0 0 1 1.119 0Zm3.304 6.245a.75.75 0 0 0-1.06 0l-3.637 3.635L8.03 9.47a.75.75 0 1 0-1.06 1.06l1.667 1.667a.751.751 0 0 0 1.06 0l4.166-4.167a.75.75 0 0 0 0-1.06Z" clip-rule="evenodd"/>
      </svg>
    `;
    firstBox.insertAdjacentHTML('beforeend', svgMarkup);
    
    const textContainer = document.createElement('div');
    textContainer.className = 'shipping-text-container';
    textContainer.appendChild(createTextBlock('top', window.themeTranslations.arrives_range.replace('{{ range }}', getDeliveryRange(3, 5))));
    
    firstBox.appendChild(textContainer);
  }
  
  container.appendChild(firstBox);

  // --- Shipping Box 2: Free & Fast (sin Express) ---
  // Mostrar cuando el usuario califica para envío gratis, incluso si no hay shipping cost definido
  // (por ejemplo, países no listados como Bermuda)
  if (qualifiesForFreeShipping) {
    const secondBox = document.createElement('div');
    secondBox.className = 'shipping-box second';
    
    // SVG del express shipping (camión) - el original de la segunda caja
    const expressSvgMarkup = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" height="18" width="18">
        <path stroke-linejoin="round" stroke-linecap="round" stroke-width="1.5" stroke="#0032A7"
          d="M5.625 7.125L12.3751 3M9.00009 9.375L15.7501 5.25M9.00009 9.375L2.25009 5.25M9.00009 9.375V16.875M7.12509 16.125V16.125C7.44574 16.3174 7.60607 16.4136 7.76491 16.4854C8.55015 16.8401 9.45003 16.8401 10.2353 16.4854C10.3941 16.4136 10.5544 16.3174 10.8751 16.125L14.1697 14.1483C15.0195 13.6384 15.4444 13.3834 15.753 13.0324C16.0261 12.7218 16.2321 12.3581 16.3579 11.9641C16.5001 11.5188 16.5001 11.0233 16.5001 10.0323V7.96771C16.5001 6.97669 16.5001 6.48117 16.3579 6.03593C16.2321 5.64192 16.0261 5.27818 15.753 4.96757C15.4444 4.61657 15.0195 4.36163 14.1697 3.85175L11.4697 2.23175C10.5718 1.69301 10.1228 1.42364 9.64356 1.31839C9.21963 1.2253 8.78055 1.2253 8.35663 1.31839C7.87736 1.42364 7.42841 1.69301 6.53051 2.23175L3.10789 4.28532C2.96114 4.37337 2.88776 4.4174 2.82122 4.46233C2.04211 4.98844 1.55467 5.84935 1.50439 6.78811C1.50009 6.86828 1.50009 6.95386 1.50009 7.125V7.125M0.75 9.75H4.75781M1.75781 12H5.50781M3.25781 14.25H6.25781"/>
      </svg>
    `;
    secondBox.insertAdjacentHTML('beforeend', expressSvgMarkup);
    
    // Contenedor de texto (misma estructura que la primera caja)
    const secondTextContainer = document.createElement('div');
    secondTextContainer.className = 'shipping-text-container';
    
    // Estructura con express_shipping pero sin funcionalidad de expand
    const expressShippingDiv = document.createElement('div');
    expressShippingDiv.className = 'express_shipping';
    
    // Solo texto "Free and fast..." (sin express shipping)
    const freeFastSpan = document.createElement('span');
    freeFastSpan.className = 'free-fast-shipping';
    const translatedCountry = window.themeData?.country_name || country;
    freeFastSpan.textContent = window.themeTranslations.free_fast_shipping.replace('{{ country }}', translatedCountry);
    
    expressShippingDiv.appendChild(freeFastSpan);
    secondTextContainer.appendChild(expressShippingDiv);
    
    // Añadir el contenedor de texto a la caja (misma estructura que primera)
    secondBox.appendChild(secondTextContainer);
    container.appendChild(secondBox);
  }

  container.style.display = 'block';
}


  function getVariantById(id) {
    return jsonDataPro.product?.variants?.find(v => v.id == id);
  }

  function createTextBlock(className, text) {
    const p = document.createElement('p');
    p.className = className;
    p.textContent = text;
    return p;
  }

  function getDeliveryRange(startDays, endDays) {
    const startDate = new Date();
    const endDate = new Date();
    
    // Get locale from multiple sources
    let locale = 'en';
    if (window.themeTranslations && window.themeTranslations.language) {
      locale = window.themeTranslations.language;
    } else if (document.documentElement && document.documentElement.lang) {
      locale = document.documentElement.lang;
    } else if (window.Shopify && window.Shopify.locale) {
      locale = window.Shopify.locale;
    }

    const dateConnector = window.themeTranslations?.date_connector || '';

    addBusinessDaysToDate(startDate, startDays);
    addBusinessDaysToDate(endDate, endDays);

    // Use Intl.DateTimeFormat to get month names and days in the correct language
    const monthFormatter = new Intl.DateTimeFormat(locale, { month: 'long' });
    const startMonthRaw = monthFormatter.format(startDate);
    const endMonthRaw = monthFormatter.format(endDate);
    // Capitalize first letter of month (uppercase for English)
    const startMonth = startMonthRaw.charAt(0).toUpperCase() + startMonthRaw.slice(1).toLowerCase();
    const endMonth = endMonthRaw.charAt(0).toUpperCase() + endMonthRaw.slice(1).toLowerCase();
    const startDay = startDate.getDate();
    const endDay = endDate.getDate();
    
    // Use Intl.RelativeTimeFormat to detect locale conventions for date ordering
    // This helps determine if the locale uses day-first or month-first format
    const dateTimeFormatter = new Intl.DateTimeFormat(locale, { 
      month: 'long', 
      day: 'numeric' 
    });
    const parts = dateTimeFormatter.formatToParts(new Date());
    const dayIndex = parts.findIndex(p => p.type === 'day');
    const monthIndex = parts.findIndex(p => p.type === 'month');
    const isDayFirst = dayIndex < monthIndex;
    
    // Format according to locale conventions
    const lang = locale.split('-')[0]; // Get base language (e.g., 'en' from 'en-US')
    const useOrdinalSuffixes = lang === 'en';
    
    // Helper to format day with ordinal suffix if needed (suffix always lowercase)
    const formatDay = (day) => {
      if (!useOrdinalSuffixes) return day;
      const suffixes = ["th", "st", "nd", "rd"];
      const n = day % 100;
      const suffix = (n >= 11 && n <= 13) ? "th" : (suffixes[n % 10] || "th");
      return `${day}${suffix}`;
    };
    
    if (startMonth === endMonth) {
      // Same month
      if (isDayFirst) {
        return `${startDay}-${endDay} ${dateConnector} ${startMonth.toUpperCase()}`.trim();
      } else {
        return `${startMonth.toUpperCase()} ${formatDay(startDay)}-${formatDay(endDay)}`;
      }
    } else {
      // Different months
      if (isDayFirst) {
        return `${startDay} ${dateConnector} ${startMonth.toUpperCase()} - ${endDay} ${dateConnector} ${endMonth.toUpperCase()}`.trim();
      } else {
        return `${startMonth.toUpperCase()} ${formatDay(startDay)} - ${endMonth.toUpperCase()} ${formatDay(endDay)}`;
      }
    }
  }

  function addBusinessDaysToDate(date, days, checkHolidays = true) {
    let count = 0;
    while (count < days) {
      date.setDate(date.getDate() + 1);
      if (date.getDay() === 0 || date.getDay() === 6) continue; // Saltar fines de semana

      const formattedDate = date.toISOString().split('T')[0];
      if (checkHolidays && holidays.has(formattedDate)) continue; // Saltar festivos
      count++;
    }
  }


  
  function createExpressContainer() {
    const expressContainer = document.createElement('div');
    expressContainer.className = 'express_container';
  
    const detailsElement = document.createElement('details');
    const summaryElement = document.createElement('summary');
  
    const expressShippingDiv = document.createElement('div');
    expressShippingDiv.className = 'express_shipping';
    expressShippingDiv.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 18 18" height="18" width="18">
        <path stroke-linejoin="round" stroke-linecap="round" stroke-width="1.5" stroke="#0032A7"
          d="M5.625 7.125L12.3751 3M9.00009 9.375L15.7501 5.25M9.00009 9.375L2.25009 5.25M9.00009 9.375V16.875M7.12509 16.125V16.125C7.44574 16.3174 7.60607 16.4136 7.76491 16.4854C8.55015 16.8401 9.45003 16.8401 10.2353 16.4854C10.3941 16.4136 10.5544 16.3174 10.8751 16.125L14.1697 14.1483C15.0195 13.6384 15.4444 13.3834 15.753 13.0324C16.0261 12.7218 16.2321 12.3581 16.3579 11.9641C16.5001 11.5188 16.5001 11.0233 16.5001 10.0323V7.96771C16.5001 6.97669 16.5001 6.48117 16.3579 6.03593C16.2321 5.64192 16.0261 5.27818 15.753 4.96757C15.4444 4.61657 15.0195 4.36163 14.1697 3.85175L11.4697 2.23175C10.5718 1.69301 10.1228 1.42364 9.64356 1.31839C9.21963 1.2253 8.78055 1.2253 8.35663 1.31839C7.87736 1.42364 7.42841 1.69301 6.53051 2.23175L3.10789 4.28532C2.96114 4.37337 2.88776 4.4174 2.82122 4.46233C2.04211 4.98844 1.55467 5.84935 1.50439 6.78811C1.50009 6.86828 1.50009 6.95386 1.50009 7.125V7.125M0.75 9.75H4.75781M1.75781 12H5.50781M3.25781 14.25H6.25781"/>
      </svg>
      <span>${window.themeTranslations.need_it_sooner}</span>
      <svg aria-hidden="true" focusable="false" class="icon icon-caret" viewBox="0 0 10 6">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor"></path>
      </svg>
    `;
  
    summaryElement.appendChild(expressShippingDiv);
    detailsElement.appendChild(summaryElement);
  
    const finalContainer = document.createElement('div');
    finalContainer.className = 'accordion__content final rte';
  
    const topParagraph = document.createElement('p');
    topParagraph.className = 'top';
    // Ensure country name is translated (use window.themeData.country_name which is always translated)
    const translatedCountry = window.themeData?.country_name || themeData.country_name;
    topParagraph.textContent = window.themeTranslations.express_to_country.replace('{{ country }}', translatedCountry);
  
    const code = themeData.country_code;
    // Use the helper function to format cost with correct currency symbol
    const costString = formatExpressCost(code);
  
    const subParagraph = document.createElement('p');
    subParagraph.className = 'sub';
    subParagraph.innerHTML = `
      ${window.themeTranslations.expected_by.replace('{{ date }}', addBusinessDays(1))} 
      <span style="float: right;color: #151414;">
        ${costString}
      </span>
    `;
  
    finalContainer.appendChild(topParagraph);
    finalContainer.appendChild(subParagraph);
    detailsElement.appendChild(finalContainer);
    expressContainer.appendChild(detailsElement);
  
    return expressContainer;
  }

  // Función auxiliar para crear solo el contenido de express shipping (sin summary/details)
  function createExpressContentOnly() {
    const finalContainer = document.createElement('div');
    finalContainer.className = 'accordion__content final rte';
  
    const topParagraph = document.createElement('p');
    topParagraph.className = 'top';
    const translatedCountry = window.themeData?.country_name || themeData.country_name;
    topParagraph.textContent = window.themeTranslations.express_to_country.replace('{{ country }}', translatedCountry);
  
    const code = themeData.country_code;
    // Use the helper function to format cost with correct currency symbol
    const costString = formatExpressCost(code);
  
    const subParagraph = document.createElement('p');
    subParagraph.className = 'sub';
    subParagraph.innerHTML = `
      ${window.themeTranslations.expected_by.replace('{{ date }}', addBusinessDays(1))} 
      <span style="float: right;color: #151414;">
        ${costString}
      </span>
    `;
  
    finalContainer.appendChild(topParagraph);
    finalContainer.appendChild(subParagraph);
  
    return finalContainer;
  }

  // --- SCROLL TOGGLES (DISABLED) ---
  // Sticky behavior commented out - not currently in use
  /*
  function setupToggleDivScroll() {
    const toggleDivs = cache.toggleDivs || document.querySelectorAll('.toggle-div');
    const firstColumn = cache.firstColumn || document.querySelector('.firstColumn');

    if (firstColumn && toggleDivs.length) {
      let lastExecution = 0;
      const debounceTime = 100;

      const handleScroll = () => {
        const firstColumnHeight = firstColumn.getBoundingClientRect().bottom;

        toggleDivs.forEach((div) => {
          if (firstColumnHeight <= window.innerHeight) {
            div.style.position = "sticky";
            div.style.padding = "16px 16px 16px 0";
          } else {
            div.style.position = "fixed";
            div.style.padding = "16px";
          }
        });
      };

      const debouncedScrollHandler = () => {
        const now = Date.now();
        if (now - lastExecution > debounceTime) {
          lastExecution = now;
          handleScroll();
        }
      };

      window.addEventListener('scroll', debouncedScrollHandler, { passive: true });
    }
  }
  */

  // --- FREQUENTLY BOUGHT INTERACTION (REMOVED) ---
  // Dead code removed for performance optimization
})();